export const DEFAULT_CANVAS_SIZE = 1080;

const isCanvasData = (value) => value && typeof value === 'object' && Array.isArray(value.layers);

export function getCanvasPayloadsFromStructure(structure) {
  if (!structure || typeof structure !== 'object') return [];

  if (isCanvasData(structure.canvas_data)) {
    return [{ id: 'design-1', title: structure.title || 'Design', canvasData: structure.canvas_data }];
  }

  if (Array.isArray(structure.slides)) {
    return structure.slides
      .map((slide, index) => {
        if (!slide || typeof slide !== 'object' || !isCanvasData(slide.canvas_data)) return null;
        return {
          id: slide.id || `slide-${index + 1}`,
          title: slide.title || `Slide ${index + 1}`,
          canvasData: slide.canvas_data,
        };
      })
      .filter(Boolean);
  }

  return [];
}

export function resolveCanvasSize(canvasData) {
  const width = Number(canvasData?.width) || DEFAULT_CANVAS_SIZE;
  const height = Number(canvasData?.height) || DEFAULT_CANVAS_SIZE;
  return { width, height };
}
